import React from 'react';
import { Row, Col } from 'antd';

const LayoutRow = props => {
	return (
		<Row className={`${props.className} content`}>
			<Col xs={1} sm={1} md={3} lg={5} />
			<Col xs={22} sm={22} md={18} lg={14} >
				{props.children}
			</Col>
			<Col xs={1} sm={1} md={3} lg={5} />
		</Row>
	);
};

export default LayoutRow;



// WEBPACK FOOTER //
// ./src/components/LayoutRow.js